import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import {number_format} from "../../../utils/formatter";

class ListTitle extends Component {

    render() {

        const { searchKeyword, totalCount, headTitle } = this.props;

        if(searchKeyword && searchKeyword != ''){

            return (
                <h3 className="tit_cont">
                    <span className="txt_result">{searchKeyword}</span> 검색결과
                    <span className="txt_count">{ (totalCount >= 0) ? number_format(totalCount) : ''}</span>
                    <Link to={"?"} className="link_back">
                        <span className="ico_blog ico_back">검색 전으로 돌아가기</span>
                    </Link>
                </h3>
            );
        }else{

            return (
                <h3 className="tit_cont">
                    {headTitle}
                    <span className="txt_count"> {number_format(totalCount)}</span>
                </h3>
            );
        }
    }
}

export default ListTitle;
